import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100px",
    height: "100px",
    borderRadius: "100%",
    position: "relative",
    margin: "0 auto",
  },
  jumpingDot: {
    display: "inline-block",
    width: "20px",
    height: "20px",
    borderRadius: "100%",
    backgroundColor: "#4B1B97",
    margin: "35px 5px",
    "&:nth-child(1)": {
      animation: "$bounce 1s ease-in-out infinite",
    },
    "&:nth-child(2)": {
      animation: "$bounce 1s ease-in-out 0.33s infinite",
      backgroundColor: "#FBBC31",
    },
    "&:nth-child(3)": {
      animation: "$bounce 1s ease-in-out 0.66s infinite",
    },
  },
  "@keyframes bounce": {
    "0%, 75%, 100%": {
      transform: "translateY(0)",
    },
    "25%": {
      transform: "translateY(-20px)",
    },
  },
}));
